// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2065":"lg-2","2236":"lg-12","2661":"lg-6","3042":"lg-9","3103":"theme-color-worker","5459":"lg-0","5470":"lg-5","6458":"lg-1","7435":"lg-8","8268":"lg-7","8279":"lg-4","8599":"lg-11","9256":"lg-3","9438":"lg-10"}[chunkId] || chunkId) + ".js";
};